import AssessmentSticker from "./assessment-sticker";
import AssessmentRaySticker from "./assessment-ray-sticker";
import AssessmentMath, { createDroppableObjects } from "./assessment-math";
import AssessmentMeshPlop from "./assessment-mesh-plop";
import RenderManager from "../rendering/render-manager";
import QuizManager from "../quizes/quiz-manager";

const plane = new THREE.Plane();
const line = new THREE.Line3();
const tmp = new THREE.Vector3();
const inverse = new THREE.Matrix4();
const originPlop = new THREE.Vector3();

const AssessmentManager = new class AssessmentManager {
    constructor() {
        this._assessments = [];

        this._wereControlsEnabled = false;
        this._inAssessmentMode = false;
        this._raycaster = new THREE.Raycaster();

        this._mouse = {
            isDown: false,
            mouseDownPosition: new THREE.Vector2(),
            lastMousePosition: new THREE.Vector2(),
            objectDownOffset: new THREE.Vector3(),
            active: null,
            object: null
        };
    }

    set inAssessmentMode(inMode) { this._inAssessmentMode = inMode; }
    get inAssessmentMode() { return this._inAssessmentMode; }
    get isAssessmentActive() { return !!this._mouse.active; }

    setLastScreenCoords(mouse) { this._mouse.lastMousePosition.copy(mouse); }

    createAssessment(type, params) {
        let assessment = null;

        switch (type) {
            case "sticker": assessment = new AssessmentSticker(params); break;
            case "ray-sticker": assessment = new AssessmentRaySticker(params); break;
            case "math-pie": assessment = new AssessmentMath(params); break;
            case "mesh-plop": assessment = new AssessmentMeshPlop(params); break;
            default: console.warn("Unkown assessment type."); return null;
        }

        this._assessments.push(assessment);

        return assessment;
    }

    _intersectPlane(mouse, out) {
        this._raycaster.setFromCamera(mouse, RenderManager.activeCamera);

        line.start.copy(this._raycaster.ray.origin);
        line.end.copy(this._raycaster.ray.direction)
            .multiplyScalar(RenderManager.activeCamera.far)
            .add(this._raycaster.ray.origin);

        return plane.intersectLine(line, out);
    }

    update() {
        if (this._mouse.active && this._mouse.isDown)
            RenderManager.activeCamera.getWorldDirection(plane.normal).negate();

        this._assessments.forEach(assessment => assessment.update());

        if (!Q3.editMode && this._mouse.active && this._mouse.isDown && !this._mouse.active.isWidget3d) {

            RenderManager.activeCamera.update = true;

            const itsct = this._intersectPlane(this._mouse.lastMousePosition, tmp);

            if (itsct) {
                const object = this._mouse.object;
                inverse.getInverse(object.parent.matrixWorld);

                object.position
                    .copy(itsct)
                    .applyMatrix4(inverse)
                    .sub(this._mouse.objectDownOffset)
            }
        }
    }

    pickup(intersection, mouse) {
        if (!intersection) return false;

        let object = intersection.object;
        const assesment = this._assessments.find(x => {
            if (x.disableInteraction) return false;

            const objects = x.object instanceof Array ? x.object : [x.object];

            let parent = object;
            while (parent) {
                if (objects.includes(parent)) {
                    object = parent;
                    return true;
                }

                parent = parent.parent;
            }


            return false;
        });

        if (!assesment) return false;

        if (!assesment.isWidget3d) {
            this._wereControlsEnabled = Q3.controls.enabled;
            Q3.controls.enabled = false;
        } else Q3.transformControls.attach(object);

        this._mouse.active = assesment;
        this._mouse.object = object;

        if (!Q3.editMode && !assesment.isWidget3d) {
            originPlop.setFromMatrixPosition(object.matrixWorld);

            RenderManager.activeCamera.getWorldDirection(plane.normal).negate();
            plane.constant = -originPlop.dot(plane.normal);

            this._mouse.isDown = true;
            this._mouse.mouseDownPosition.copy(mouse);

            assesment.pickup(object);

            this._mouse.objectDownOffset.set(0, 0, 0);
            this._intersectPlane(this._mouse.lastMousePosition, this._mouse.objectDownOffset);

            inverse.getInverse(object.parent.matrixWorld);

            this._mouse.objectDownOffset
                .applyMatrix4(inverse)
                .sub(object.position);
        }

        QuizManager.deactivateUI();

        return true;
    }

    release() {
        if (!Q3.editMode && this._mouse.active && this._mouse.isDown) {
            this._mouse.active.release(this._mouse.object);

            const valid = this._assessments.filter(ass => {
                const objects = ass.object instanceof Array ? ass.object : [ass.object];
                const includes = objects.includes(this._mouse.object);

                return includes;
            });

            for (let i = 0; i < valid.length; i++) {
                if (valid[i].check(this._mouse.lastMousePosition, this._mouse.object)) break;
            }

            if (!this._mouse.active.isWidget3d) Q3.controls.enabled = this._wereControlsEnabled;
            else Q3.transformControls.detach();
        }

        QuizManager.activateUI();

        this._mouse.object = null;
        this._mouse.active = null;
        this._mouse.isDown = false;
    }

    get assessments() { return this._assessments; }

    destroy(assessment) {
        const idx = this._assessments.indexOf(assessment);

        if (idx > -1) {
            this._assessments.splice(idx, 1);
            assessment.destroy();
        }

    }

    getAssessment(object) {
        const ass = this._assessments.find(ass => {
            const objects = ass.object;

            return (objects instanceof Array ? objects : [objects]).includes(object);
        });

        return ass;
    }

    clearAssessments() {
        let ass;

        while (ass = this._assessments.pop()) {
            ass.destroy();
        }
    }
}

let droppable = null;
function createPieAssessment(pieCount, onChange) {
    droppable = droppable || createDroppableObjects(4, "pizza", false);
    const objects = droppable.objects;
    const tray = droppable.tray;
    droppable.objects.forEach(o => o.visible = true)
    droppable.parent.position.set(0, 0, 4);

    let assessments = [];
    for (let i = 0; i < pieCount; i++) {
        assessments.push(AssessmentManager.createAssessment("math-pie", { tray, denominator: 4, objects, position: new THREE.Vector3(2.5 * i - 2, 0, 2), onChange: cb }))
    }

    function cb() { if (onChange) onChange(assessments.map((assessment) => assessment.getValue())) }

    return { assessments, objects };
};

function clearAssessments() {
    AssessmentManager.assessments.slice().forEach(ass => AssessmentManager.destroy(ass));
    AssessmentManager._assessments = [];
    if (droppable) droppable.objects.forEach(o => o.visible = false)
};

function removePieAssessment(assessments, objects) {
    assessments.forEach(ass => AssessmentManager.destroy(ass));
    objects.forEach(o => o.visible = false);
};

export default AssessmentManager;
export { AssessmentManager, removePieAssessment, clearAssessments, createPieAssessment };